import { useCallback, useState } from 'react'

const useRefresh = (): (() => void) => {
  const [, setState] = useState(false)

  return useCallback(() => setState(prev => !prev), [])
}

export default useRefresh
